/**
 * referentiel.js — Squelette du Permis AM · Option QUADRICYCLE LÉGER À MOTEUR
 *
 * Basé sur l'ANNEXE II de l'arrêté du 8 novembre 2012 modifié,
 * et notamment de l'arrêté du 30 juillet 2021.
 * Version consolidée au 1er mars 2024 sur Légifrance.
 *
 * Contenu 100 % conforme au référentiel officiel + enrichissement pédagogique
 * ajouté par Code 2 Roues (nettement séparé par les composants RefOfficiel /
 * RefEnrichi).
 *
 * ⚠️ IMPORTANT : le texte réglementaire mélange parfois cyclomoteur et
 * quadricycle. Ici on n'affiche QUE ce qui concerne le quadricycle léger.
 */

export const FORMATION_META = {
  id: 'permis-am-voiturette',
  title: 'Permis AM · Option Quadricycle léger à moteur',
  subtitle: 'Aussi appelée « voiturette » ou VSP — Véhicule Sans Permis',
  totalDuree: '8 h minimum',
  repartition: '2 jours minimum · 4 h maximum par jour',
  conduiteEffective: '6 h minimum (séquences 2 + 4)',
  ageMini: '14 ans (ou dérogation 15 ans conduite accompagnée)',
  sourceOfficielle: 'Annexe II · Arrêté du 8 novembre 2012 modifié (arrêté 30/07/2021 · v. 01/03/2024)',
  sourceUrl: 'https://www.legifrance.gouv.fr/loda/id/JORFTEXT000026611026/',
};

export const SEQUENCES = [
  {
    id: 'sequence-1',
    num: 1,
    slug: 'representations',
    duree: '30 min',
    dureeMini: 30,
    kicker: 'SÉQUENCE 1',
    title: 'Échanges sur les représentations individuelles autour de la conduite',
    shortTitle: 'Représentations individuelles',
    subtitle: "Ce que je pense savoir avant de conduire",
    color: '#0891b2',
    icon: 'MessagesSquare',
    poster: '/images/voiturette/voiturette-1-decouvre.png',
    posterAlt: 'Découvre ma voiturette — infographie Code 2 Roues',
  },
  {
    id: 'sequence-2',
    num: 2,
    slug: 'hors-circulation',
    duree: '1 h min',
    dureeMini: 60,
    kicker: 'SÉQUENCE 2',
    title: "Formation à la conduite hors circulation",
    shortTitle: 'Maîtrise hors circulation',
    subtitle: "Équipement · découverte du véhicule · maniabilité",
    color: '#22c55e',
    icon: 'Car',
    poster: '/images/voiturette/voiturette-2-regarder-controler.png',
    posterAlt: 'Regarder · Contrôler · Anticiper — routine avant de démarrer',
  },
  {
    id: 'sequence-3',
    num: 3,
    slug: 'code',
    duree: '30 min',
    dureeMini: 30,
    kicker: 'SÉQUENCE 3',
    title: 'Apports théoriques — Code de la route',
    shortTitle: 'Code de la route',
    subtitle: 'Signalisation · règles de circulation · priorités',
    color: '#f59e0b',
    icon: 'BookOpen',
    poster: '/images/voiturette/voiturette-3-freiner-arreter.png',
    posterAlt: 'Freiner et s\'arrêter — maîtrise pour ta sécurité',
  },
  {
    id: 'sequence-4',
    num: 4,
    slug: 'circulation',
    duree: '3 h min',
    dureeMini: 180,
    kicker: 'SÉQUENCE 4',
    title: 'Formation à la conduite sur voies ouvertes',
    shortTitle: 'Circulation en situation réelle',
    subtitle: '10 compétences clés pour rouler en sécurité',
    color: '#e11d48',
    icon: 'Route',
    poster: '/images/voiturette/voiturette-4-difference-vitesse.png',
    posterAlt: 'La différence de vitesse — anticipe les autres véhicules',
  },
  {
    id: 'sequence-5',
    num: 5,
    slug: 'sensibilisation',
    duree: '1 h min',
    dureeMini: 60,
    kicker: 'SÉQUENCE 5',
    title: 'Sensibilisation aux risques',
    shortTitle: 'Sensibilisation aux risques',
    subtitle: "7 thèmes officiels · au moins 4 traités · présence parentale si mineur",
    color: '#a855f7',
    icon: 'ShieldAlert',
  },
];

/** Retourne les métadonnées de la séquence courante depuis le slug d'URL. */
export function findSequenceBySlug(slug) {
  return SEQUENCES.find((s) => s.slug === slug) || null;
}
